import { Enums } from '../common/enums'
import { DataType } from '../../helpers/common-helper'
import { Utils } from '../util/utils'
import { DataProvider } from '../../helpers/data-provider'
import { Dictionary } from '../../helpers/dictionary'
import { CommonHelper } from '../../helpers/common-helper'

import { OpDescr } from '../core/op-descr'
import { OpFile } from '../core/op-file'
import { OpDashboardControl } from './op-dashboard-control'
import { OpDashboardGroup } from './op-dashboard-group'
import { OpEnumObject } from './op-enum-object'


export class OpChartSeriesPoint {
    //Properties
    public xValue: any
    public yValue: any
    public referenceData: any[]
    //Properties end

    constructor(opObj: any) {
        if (opObj) {
            this.xValue = opObj.XValue
            this.yValue = opObj.YValue
            this.referenceData = opObj.referenceData
        }
        if (!this.referenceData)
            this.referenceData = []
    }
}